import React, { useState } from 'react';
import { Menu, X, Phone, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../mock';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-sage-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_authentic-ayurveda-2/artifacts/xevqzcml_image.png" 
              alt="Vedankur Ayurveda" 
              className="h-14 w-14 object-contain"
            />
            <div>
              <h1 className="text-xl font-serif font-bold text-forest-green leading-tight">
                Vedankur Ayurveda
              </h1>
              <p className="text-xs text-sage-green">Panchakarma Centre</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-forest-green hover:text-sage-green font-medium transition-colors duration-300"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-3">
            <a
              href={contactInfo.customGPT}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-sage-green hover:text-forest-green transition-colors duration-300 flex items-center gap-1"
            >
              <Sparkles className="w-4 h-4" />
              Aajjicha Batwa GPT
            </a>
            <a href={`tel:${contactInfo.phone}`}>
              <Button className="bg-sage-green hover:bg-forest-green text-white transition-all duration-300">
                <Phone className="w-4 h-4 mr-2" />
                Book Consultation
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-forest-green"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4 animate-accordion-down">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="block text-forest-green hover:text-sage-green font-medium transition-colors duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <Button className="w-full bg-sage-green hover:bg-forest-green text-white">
              <Phone className="w-4 h-4 mr-2" />
              <a href={`tel:${contactInfo.phone}`} className="text-white">
                Book Consultation
              </a>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
